import { render } from "./MasterDashboard.vue?vue&type=template&id=605d2bf8&scoped=true"
import script from "./MasterDashboard.vue?vue&type=script&lang=js"
export * from "./MasterDashboard.vue?vue&type=script&lang=js"

import "./MasterDashboard.vue?vue&type=style&index=0&id=605d2bf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605d2bf8"]])

export default __exports__